import React, { memo } from "react";
import { Link } from "react-router-dom";
import {
  HiOutlineEye,
  HiOutlineLogin,
  HiOutlineUser,
} from "react-icons/hi";

const TenantListRowActions = memo(
  ({
    row,
    canEnterTenant,
    canStartGhost,
    tenantContextSpId,
    onEnterTenant,
    onGhostTarget,
  }) => (
    <div
      className="inline-flex items-center gap-1"
      onClick={(event) => event.stopPropagation()}
      onKeyDown={(event) => event.stopPropagation()}
    >
      <Link
        to={`/tenants/${row.id}`}
        className="rounded-lg p-2 text-gray-500 hover:bg-gray-100 hover:text-indigo-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500"
        title="View tenant"
      >
        <HiOutlineEye className="h-4 w-4" aria-hidden="true" />
        <span className="sr-only">View tenant</span>
      </Link>
      <button
        type="button"
        disabled={!canEnterTenant || tenantContextSpId === row.id}
        title={
          !canEnterTenant
            ? "Missing platform.tenant.enter permission"
            : tenantContextSpId === row.id
              ? "Already operating in this tenant"
              : "Enter tenant context"
        }
        onClick={() =>
          onEnterTenant({
            spId: row.id,
            spName: row.name,
          })
        }
        className="rounded-lg p-2 text-gray-500 hover:bg-gray-100 hover:text-indigo-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 disabled:cursor-not-allowed disabled:text-gray-300"
      >
        <HiOutlineLogin className="h-4 w-4" aria-hidden="true" />
        <span className="sr-only">Enter tenant</span>
      </button>
      <button
        type="button"
        disabled={!canStartGhost || !row.owner?.id}
        title={
          !canStartGhost
            ? "Missing platform.ghost.start permission"
            : !row.owner?.id
              ? "Tenant owner not available"
              : "Ghost as this user"
        }
        onClick={() => onGhostTarget(row)}
        className="rounded-lg p-2 text-gray-500 hover:bg-gray-100 hover:text-indigo-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 disabled:cursor-not-allowed disabled:text-gray-300"
      >
        <HiOutlineUser className="h-4 w-4" aria-hidden="true" />
        <span className="sr-only">Ghost as user</span>
      </button>
    </div>
  )
);

TenantListRowActions.displayName = "TenantListRowActions";

export default TenantListRowActions;
